import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FormControl, FormLabel, Input, Checkbox, Button, Flex, Text } from '@chakra-ui/react';
import axios from 'axios';
import ReCAPTCHA from 'react-google-recaptcha';

import { useLanguage } from '../../components/LanguageContext';

const CreateAccount = ({ onNext }) => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    retypePassword: '',
    isCertifiedAge: false,
    stage: "personal-info"
  });
  const [passwordMatch, setPasswordMatch] = useState(true);
  const navigate = useNavigate();
  const { language } = useLanguage();
  const isEnglish = language === "en";
  const [recaptchaToken, setRecaptchaToken] = useState(null);
  

  const handleRecaptchaChange = (token) => {
    console.log("Captcha token:", token);
    setRecaptchaToken(token);
  };

  const handleChange = (e) => {
  const { name, value, checked, type } = e.target;

  if (name === 'retypePassword') {
    setFormData({ ...formData, retypePassword: value });
    setPasswordMatch(value === formData.password);
  } else {
    setFormData({ ...formData, [name]: type === 'checkbox' ? checked : value });
  }
};


  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!passwordMatch) {
      alert(isEnglish ? "Passwords do not match" : "Las contraseñas no coinciden");
      return;
    }
    if (formData.password.length < 6) {
      alert(isEnglish ? "Password must be at least 6 characters long" : "La contraseña debe tener al menos 6 caracteres");
      return;
    }

    if (!recaptchaToken) {
      alert("Please complete the reCAPTCHA.");
      return;
    }

    try {
      const { data } = await axios.post("/api/register/create-account", {
        ...formData,
        recaptchaToken
      });
      console.log(data);
      // You might want to handle the response accordingly

      navigate(`/signup/personal-info`);
    } catch (error) {
      if (error.response?.status === 400) {
        alert(isEnglish ? "User already exists" : "El usuario ya existe");
      } else {
        alert("System Error, please try again later..");
      }
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <Flex
        align="center"
        wrap="wrap"
        justify="space-around"
        minHeight={{ base: "60vh", lg: "50vh" }}
        maxW={{ base: "md", lg: "lg" }}
        mt={8}
        p={8}
      >
        <Flex
          align="space-between" // evenly space the first and last name inputs
          width="100%" // ensure the Flex container takes up the full width
          direction={{ base: "column", lg: "row" }}
        >
          <FormControl
            pr={{ base: "0", lg: "4" }}
            mb={{ base: "4", lg: "0" }}
            isRequired
          >
            <FormLabel fontSize="md">{isEnglish ? "Legal First Name" : "Nombre legal"}</FormLabel>
            <Input type="text" name="firstName" value={formData.firstName} onChange={handleChange} color="blue.600" required />
          </FormControl>
          <FormControl
            pl={{ base: "0", lg: "4" }}
            isRequired
          >
            <FormLabel fontSize="md">{isEnglish ? "Legal Last Name" : "Apellido legal"}</FormLabel>
            <Input type="text" name="lastName" value={formData.lastName} onChange={handleChange} color="blue.600" required />
          </FormControl>
        </Flex>
        <FormControl mt={4} isRequired>
          <FormLabel fontSize="md">{isEnglish ? "Email" : "Correo electrónico"}</FormLabel>
          <Input type="email" name="email" value={formData.email} onChange={handleChange} color="blue.600" required />
        </FormControl>
        <FormControl mt={4} isRequired>
          <FormLabel fontSize="md">{isEnglish ? "Password" : "Contraseña"}</FormLabel>
          <Input type="password" name="password" value={formData.password} onChange={handleChange} color="blue.600" required />
        </FormControl>
        <FormControl mt={4} isRequired>
          <FormLabel fontSize="md">{isEnglish ? "Re-Type Password" : "Reescriba la contraseña"}</FormLabel>
          <Input type="password" name="retypePassword" value={formData.retypePassword} onChange={handleChange} color="blue.600" required />
          {!passwordMatch && (
            <Text mt={1} color="red.500">{isEnglish ? "Passwords do not match" : "Las contraseñas no coinciden"}</Text>
          )}
        </FormControl>
        <FormControl mt={4} isRequired>
          <Checkbox name="isCertifiedAge" isChecked={formData.isCertifiedAge} onChange={handleChange} colorScheme="blue">
          {isEnglish ? "I certify that I am over 18 years old." : "Certifico que tengo más de 18 años."}
          </Checkbox>
        </FormControl>
        <FormControl mt={4}>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <ReCAPTCHA
              sitekey="6LfXJ-8rAAAAAPIdvr0J4_Tt_nijwh_6asS3GtFj"
              onChange={handleRecaptchaChange}
            />
          </div>
        </FormControl>

        <Button type="submit" colorScheme="blue" mt={4} isDisabled={!recaptchaToken || !passwordMatch || !formData.isCertifiedAge}>Next</Button>
      </Flex>
    </form>
  );
};

export default CreateAccount;
